var installedModules = {};
var moduleToHandlerMapping = {
	66375: {
		getter: () => (() => (__webpack_require__(50374))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	74932: {
		getter: () => (() => (__webpack_require__(6073))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	12966: {
		getter: () => (() => (__webpack_require__(15478))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	56562: {
		getter: () => (__webpack_require__.e(1254).then(() => (() => (__webpack_require__(11254))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.1.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux",
	},
	89598: {
		getter: () => (Promise.all([__webpack_require__.e(8934), __webpack_require__.e(2966)]).then(() => (() => (__webpack_require__(18934))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~8.0.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	690: {
		getter: () => (__webpack_require__.e(65).then(() => (() => (__webpack_require__(90065))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.2.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-dynamic-modules-thunk",
	},
	15943: {
		getter: () => (Promise.all([__webpack_require__.e(6241), __webpack_require__.e(3406), __webpack_require__.e(582), __webpack_require__.e(2031), __webpack_require__.e(2458), __webpack_require__.e(9840), __webpack_require__.e(5032), __webpack_require__.e(144), __webpack_require__.e(133), __webpack_require__.e(4182), __webpack_require__.e(344), __webpack_require__.e(5970), __webpack_require__.e(7557), __webpack_require__.e(5574), __webpack_require__.e(3685), __webpack_require__.e(7562), __webpack_require__.e(4092)]).then(() => (() => (__webpack_require__(67557))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~8.0.20",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bentley/itwin-enablement-api",
	},
	57267: {
		getter: () => (__webpack_require__.e(2030).then(() => (() => (__webpack_require__(39649))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.2.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-dynamic-modules",
	},
	99225: {
		getter: () => (Promise.all([__webpack_require__.e(2155), __webpack_require__.e(9305), __webpack_require__.e(6528), __webpack_require__.e(9261), __webpack_require__.e(8420), __webpack_require__.e(5050), __webpack_require__.e(5263), __webpack_require__.e(6840), __webpack_require__.e(2258), __webpack_require__.e(4028)]).then(() => (() => (__webpack_require__(8420))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.8.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@itwin/core-common",
	},
	10592: {
		getter: () => (() => (__webpack_require__(23360))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	36376: {
		getter: () => (__webpack_require__.e(62).then(() => (() => (__webpack_require__(60062))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.4.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-thunk",
	},
	34193: {
		getter: () => (__webpack_require__.e(8739).then(() => (() => (__webpack_require__(48739))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.4.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-thunk",
	},
	95685: {
		getter: () => (Promise.all([__webpack_require__.e(3657), __webpack_require__.e(844), __webpack_require__.e(6756), __webpack_require__.e(4007), __webpack_require__.e(8108), __webpack_require__.e(3531), __webpack_require__.e(9762), __webpack_require__.e(8314), __webpack_require__.e(7797)]).then(() => (() => (__webpack_require__(79762))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=3.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@itwin/itwinui-react",
	},
	31573: {
		getter: () => (Promise.all([__webpack_require__.e(5633), __webpack_require__.e(6557), __webpack_require__.e(1776), __webpack_require__.e(844), __webpack_require__.e(2529), __webpack_require__.e(9167), __webpack_require__.e(4946), __webpack_require__.e(5018), __webpack_require__.e(1220)]).then(() => (() => (__webpack_require__(48016))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=3.0.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@itwin/itwinui-react",
	},
	65110: {
		getter: () => (Promise.all([__webpack_require__.e(8008), __webpack_require__.e(5961), __webpack_require__.e(9481), __webpack_require__.e(1564), __webpack_require__.e(303), __webpack_require__.e(4910), __webpack_require__.e(9759), __webpack_require__.e(4703), __webpack_require__.e(9995), __webpack_require__.e(9694), __webpack_require__.e(17), __webpack_require__.e(5181), __webpack_require__.e(5808), __webpack_require__.e(5799), __webpack_require__.e(9721), __webpack_require__.e(1369), __webpack_require__.e(4383), __webpack_require__.e(4083), __webpack_require__.e(4932), __webpack_require__.e(3387), __webpack_require__.e(4428), __webpack_require__.e(5022), __webpack_require__.e(5144), __webpack_require__.e(1345), __webpack_require__.e(5979), __webpack_require__.e(7412), __webpack_require__.e(1625), __webpack_require__.e(5318), __webpack_require__.e(9009), __webpack_require__.e(6266), __webpack_require__.e(7281), __webpack_require__.e(5033), __webpack_require__.e(4947), __webpack_require__.e(5331), __webpack_require__.e(8156), __webpack_require__.e(2865), __webpack_require__.e(3372), __webpack_require__.e(9290), __webpack_require__.e(7615), __webpack_require__.e(7538), __webpack_require__.e(6640), __webpack_require__.e(2105), __webpack_require__.e(3167)]).then(() => (() => (__webpack_require__(55333))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.8.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@itwin/core-frontend",
	},
	80672: {
		getter: () => (__webpack_require__.e(297).then(() => (() => (__webpack_require__(70297))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~8.0.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	99697: {
		getter: () => (__webpack_require__.e(802).then(() => (() => (__webpack_require__(90802))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.2.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-dynamic-modules-thunk",
	},
	17018: {
		getter: () => (Promise.all([__webpack_require__.e(3406), __webpack_require__.e(582), __webpack_require__.e(2031), __webpack_require__.e(2458), __webpack_require__.e(9840), __webpack_require__.e(5032), __webpack_require__.e(144), __webpack_require__.e(133), __webpack_require__.e(4182), __webpack_require__.e(1504), __webpack_require__.e(4401), __webpack_require__.e(4654), __webpack_require__.e(1664), __webpack_require__.e(6046), __webpack_require__.e(4756), __webpack_require__.e(5750)]).then(() => (() => (__webpack_require__(81664))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~8.0.20",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bentley/itwin-enablement-api",
	}
};
var initialConsumes = [66375,74932];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"65": [
		36376
	],
	"593": [
		65110,
		80672
	],
	"802": [
		34193
	],
	"1293": [
		10592
	],
	"1475": [
		56562,
		89598
	],
	"1573": [
		31573
	],
	"1772": [
		17018
	],
	"2966": [
		12966
	],
	"5407": [
		690,
		15943,
		57267
	],
	"5685": [
		95685
	],
	"8792": [
		66375,
		74932
	],
	"9225": [
		99225
	],
	"9697": [
		99697
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}